import React from 'react';
import { StepIconProps } from '@mui/material';
import { makeStyles } from '@mui/styles';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck } from '@fortawesome/free-solid-svg-icons';
import clsx from 'clsx';

export const LessonAssignmentStepper: React.FC<StepIconProps> = (props: StepIconProps) => {
  const classes = useStyles();
  const { active, completed, icon } = props;

  return (
    <div className={classes.active}>
      {completed ? (
        <FontAwesomeIcon className={classes.completed} icon={faCheck} />
      ) : (
        <div
          className={clsx(classes.circle, {
            [classes.activeCircle]: active
          })}
        >
          <span
            className={clsx(classes.active, {
              [classes.activeFont]: active
            })}
          >
            {icon}
          </span>
        </div>
      )}
    </div>
  );
};

const useStyles = makeStyles({
  active: {
    color: '#000000'
  },
  activeFont: {
    color: '#fff'
  },
  circle: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '50px !important',
    width: '50px !important',
    border: '4px solid #000000',
    borderRadius: '50%',
    backgroundColor: '#fff'
  },
  activeCircle: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '58px',
    width: '58px',
    borderRadius: '50%',
    backgroundColor: '#000'
  },
  completed: {
    color: '#000',
    border: '4px solid',
    borderRadius: '50%',
    backgroundColor: '#74B23B',
    zIndex: 1,
    padding: '14px',
    fontSize: '24px',
    marginLeft: '-3px'
  },
  check: {
    fontSize: '15px'
  }
});
